<template>
  <div>
    <v-row style="background-color: #f5f5f5">
      <v-col class="text-center">
        <img alt="Controller" src="../../../assets/logo.png" class="logo" style="height: 60px;">
      </v-col>
    </v-row>
    <v-card flat tile class="text-center pa-2">
      <v-btn small rounded depressed color="primary" :to="{ name: 'dashboardInfo' }" class="mr-2">Relatórios</v-btn>
      <v-btn v-if="financial_enabled" small rounded depressed color="primary" :to="{ name: 'dashboardFinancial' }" class="mr-2">Financeiro</v-btn>
    </v-card>
    <v-container class="pb-0">
      <h1 class="title">{{ project.title }}</h1>
    </v-container>
  </div>
</template>

<script>
export default {
  props: {
    project: {
      type: Object,
      default: {}
    }
  },
  computed: {
    financial_enabled() {
      if (this.project.plan_start_at !== '0000-00-00') {
        const plan_start = new Date(this.project.plan_start_at);
        const today = new Date();

        return plan_start.getTime() <= today.getTime();
      }
    }
  }
}
</script>

<style>

</style>
